export default __webpack_public_path__ + "static/media/ic_uncheck_create_user.1b681e53.svg";